import { useConfirm } from 'components/Alert/useConfirm';
import { useMutation } from 'query';
import { moreInfo } from 'scenes/FinancePage/FR/data/queryKeyFactory';
import { moreInfoFR } from 'scenes/FinancePage/FR/sources';

export const useMoreInfo = () => {
  const confirm = useConfirm();

  const approveMutation = useMutation(moreInfo(), moreInfoFR, {
    refresh: true,
    successMessage: () => `More info requested`,
  });

  const handleAction = ({ id }: any) => {
    //todo ask comment in confirm dialog
    confirm({
      title: `Request More Info about the Financial Result?`,
      confirmActionLabel: 'Request More Info',
    }).then(() => approveMutation.mutateAsync({ id, comment: '' }));
  };

  return [handleAction, approveMutation];
};
